export default "__VITE_ASSET__qeEzqDbT__"